export default {
  init() {
    // JavaScript to be fired
    const select2 = $('select.select2');
    if (select2.length) {
      select2.each(function() {
        const _this = $(this);
        const placeholder = _this.data('placeholder');
        const containerCssClass = _this.data('container-css-class');
        const dropdownCssClass = _this.data('dropdown-css-class');
        const formatOptionLabel = _this.data('format-option-label');
        const args = {};

        if (_this.hasClass('no-search-box')) {
          args['minimumResultsForSearch'] = -1;
        } else if (_this.hasClass('infinity')) {
          args['minimumResultsForSearch'] = Infinity;
        }

        if (placeholder) {
          args['placeholder'] = placeholder;
        }

        if (containerCssClass) {
          args['containerCssClass'] = containerCssClass;
        }

        if (dropdownCssClass) {
          args['dropdownCssClass'] = dropdownCssClass;
        }

        if (formatOptionLabel) {
          args['templateResult'] = function(state) {
            if (!state.id) {
              return state.text;
            }

            return $(`<span class="${$(state.element).data('class')}">${state.text}</span>`);
          };
        }

        if (_this.attr('name') === 'neighborhoodSortTypes') {
          args['templateResult'] = function(state) {
            const getStringAfterBg = (str) => {
              if (typeof str === 'string' && str) {
                const parts = str.split('bg-');
                return parts.length > 1 ? parts[1] : '';
              }
              return '';
            };

            const color = getStringAfterBg(state.id);
            return $(`<label for="${state.id}"><div style="background:${color}"></div>${state.text}</label><input type="radio" id="${state.id}"/>`);
          };
        }

        _this.select2(args);
      });

      // Removes tooltip
      $('.select2-selection__rendered').each(function () {
        $(this).removeAttr('title');
      });
    }
  },
  finalize() {
    // JavaScript to be fired, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/components/selects.js